import React, { useEffect } from "react";
import "./MobileNav.scss";
import { MdKeyboardArrowDown } from "react-icons/md";
import { NavLink as Link } from "react-router-dom";
import Logo from "../Nav/Logo/Logo";
// import Contact from "../Nav/Auth/Auth";
import StyledLink from "../StyledLink/StyledLink";
import { FormattedMessage } from "react-intl";
import {
  BsArrowRight,
  BsFillPlusCircleFill,
  BsFillQuestionCircleFill,
} from "react-icons/bs";
import SelectLanguage from "../SelectLanguage/SelectLanguage";
import ThemeSwitcher from "../Footer/ThemeSwitcher";
import {
  AiTwotoneSetting,
  AiOutlineMobile,
  AiOutlineClose,
} from "react-icons/ai";
import {
  aboutData,
  advertiserData,
  MainData,
  publisherData,
  resourcesData,
} from "../Nav/Menu/menuData";
import { caseData } from "./data";
function MobileNav() {
  useEffect(() => {
    const linkArrows = document.querySelectorAll(".mobileNav__icon");
    const links = document.querySelectorAll(".mobileNav__link--dropdown");

    [...links].forEach((link) => {
      link.addEventListener("click", (e) => {
        const navArrow = link.querySelector(".mobileNav__arrow");
        const dropdownNav = link.querySelector(".mobileNav__dropdown");

        dropdownNav.classList.toggle("mobileNav__show");

        if (
          e.target.parentElement.classList.contains("mobileNav__icon") ||
          e.target.parentElement.classList.contains("mobileNav__arrow") ||
          e.target.classList.contains("mobileNav__icon")
        ) {
          if (dropdownNav.classList.contains("mobileNav__show")) {
            dropdownNav.style.height = dropdownNav.scrollHeight + "px";
          } else {
            dropdownNav.style.height = 0;
          }

          navArrow.classList.toggle("arrowShow");
        }
      });
    });
  }, []);

  return (
    <div className="mobileMenu">
      <div className="fixedBack "></div>
      <div className="mobileNav">
        <div className="blue-side">
          <Logo />

          <StyledLink
            to="/contact"
            styles="unstyled"
            linkName={
              <FormattedMessage id="contact-us" defaultMessage="Contact us" />
            }
            fontSize="max(18px,2.5vw)"
            linkColor="#fff"
            fontWeight="600"
            rightIcon={<BsArrowRight />}
            rightIconColor="#fff"
            rightIconSize="max(20px,3.5vw)"
            flexDirection="column"
            alignItems="flex-start"
          />

          <div className="bottom-description">
            <h1>
              <FormattedMessage
                id="Work"
                defaultMessage="Let's work together"
              />
            </h1>

            <p>info@ylliri.com</p>

            <p>+383 45 111 222</p>
          </div>
        </div>

        <div className="mobileNav__close">
          <div className="mobileNav__closebox">
            <AiOutlineClose className="mobileNav__closeicn" />
          </div>
        </div>

        <div className="right-side">
          <ul className="mobileNav__list">
            <span className="color">
              <FormattedMessage
                id="WeAre"
                defaultMessage="WE ARE YLLIRI"
              />
            </span>
            {MainData.map((props, i) => {
              return (
                <li
                  key={i}
                  className="mobileNav__link mobileNav__link--dropdown"
                >
                  <div className="circle"></div>
                  <Link
                    to={props.to}
                    className="mobileNav__al"
                    activeClassName="mobileNav__activeLink"
                  >
                    {props.link}
                    <BsArrowRight className="arrow" />
                  </Link>{" "}
                </li>
              );
            })}
          </ul>

          <div className="case-studies">
            <span className="color">
              <FormattedMessage
                id="CaseStudies"
                defaultMessage="case studies"
              />
            </span>
            {caseData.map((props, i) => {
              return (
                <div key={i} className="item">
                  <h1 className="mid-title">{props.title}</h1>
                  <p className="def-text">{props.text}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="bottom-description  description2">
          <h1>
            <FormattedMessage
              id="Work"
              defaultMessage="Let's work together"
            />
          </h1>

          <div className="flex">
            <p>info@ylliri.com</p>

            <p>+383 45 111 222</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileNav;
